export const adaptPurchaseButtonInfoV2_2 = (result) => {
    if (!result || !result.data) {
        console.warn('[adaptPurchaseButtonInfoV2_2] Respuesta inválida o sin data:', result);
        return {
            response: {},
            status: '1',
            msg: 'Adapter: respuesta vacía o sin propiedad data',
        };
    }

    const {
        listButtons       = { button: [] },
        playButton        = { visible: '0' },
        downloadButton    = { visible: '0' },
        playFreemiumButton= { visible: '0' },
        bannerpromo       = '',
        timeshift         = '',
        accessCode        = { enabled: false, msgAccessCode: '' },
    } = result.data;

    return {
        response: {
            listButtons,
            playButton,
            downloadButton,
            playFreemiumButton,
            bannerpromo,
            timeshift,
            accessCode,
        },
        status: '0',
        msg: 'OK',
    };
};


// WEBPACK FOOTER //
// ./src/requests/adapters/payway/purchaseButtonInfoV2_2.adapter.js